/**
 * @file Main entry point for the application.
 * Starts the staged auth/bootstrap sequence.
 */

import { startBootstrap } from "./auth/bootstrap.js";

startBootstrap();
